<template>
  <div class="no-select">
    <label class="wrapper_label">{{label}}</label>
    <div class="i_wrp">
       <input
           :name="name"
           :value="value"
           autocomplete="off"
           @blur="$emit('blur')"
           @input="$emit('input', $event.target.value)"
           @keyup.enter="$emit('enter')"
           class="wrapper_input"
           :type="show ? 'text' : 'password'"
       >
      <div class="icon" @click="show = !show">
        <svg v-if="show" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="#2CB181" d="M 12 4 C 4 4 1 12 1 12 C 1 12 4 20 12 20 C 20 20 23 12 23 12 C 23 12 20 4 12 4 z M 12 6 C 17.276 6 19.944594 10.267094 20.808594 11.996094 C 19.943594 13.713094 17.255 18 12 18 C 6.724 18 4.0554062 13.732906 3.1914062 12.003906 C 4.0574062 10.286906 6.745 6 12 6 z M 12 8 C 9.791 8 8 9.791 8 12 C 8 14.209 9.791 16 12 16 C 14.209 16 16 14.209 16 12 C 16 9.791 14.209 8 12 8 z M 12 10 C 13.105 10 14 10.895 14 12 C 14 13.105 13.105 14 12 14 C 10.895 14 10 13.105 10 12 C 10 10.895 10.895 10 12 10 z"></path>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="#2CB181" d="M 12 4 C 4 4 1 12 1 12 C 1 12 4 20 12 20 C 20 20 23 12 23 12 C 23 12 20 4 12 4 z M 12 7 C 14.761 7 17 9.239 17 12 C 17 14.761 14.761 17 12 17 C 9.239 17 7 14.761 7 12 C 7 9.239 9.239 7 12 7 z M 12 9 A 3 3 0 0 0 9 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 12 A 3 3 0 0 0 12 9 z"></path>
        </svg>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "app-password",
  props: {
    name: {
      type: String,
      default: 'password'
    },
    value: {
      type: String
    },
    label: {
      type: String,
      default: 'Пароль'
    },
  },
  data: () => ({
    show: false
  })
}
</script>

<style scoped lang="scss">
.wrapper_input{
  margin-top: 0px;
}
.i_wrp{
  position: relative;

  & .icon{
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    margin-top: -10px;
    top: 50%;
    right: 10px;

    & * {
      margin-top: 0;
    }
  }
}

.wrapper_input {
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  height: 40px;
  width: 100%;
  outline: none;
  padding: 0 15px;
  color: #7A818F;
  font-size: 12px;
  line-height: 14px;

}
</style>
